<div class="modal-header">
  <h4 class="modal-title">Send Feedback</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('cross click')"></button>
</div>

<div class="modal-body">
  <form>
    <div class="mb-3">
      <label class="form-label">To</label>
      <input type="email" class="form-control" [(ngModel)]="to" name="to" readonly />
    </div>

    <div class="mb-3">
      <label class="form-label">Subject</label>
      <input type="text" class="form-control" [(ngModel)]="subject" name="subject" />
    </div>

    <div class="mb-3">
      <label class="form-label">Message</label>
      <textarea class="form-control" [(ngModel)]="body" name="body" rows="5"></textarea>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="submit()">Send</button>
</div>
